import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { PermissionsService } from '@app/services/permissions/permissions.service';
@Injectable(
  {
    providedIn: 'root'
  }
)

export class RoleguardService implements CanActivate, OnDestroy {
  baseinfoSubscription: Subscription;
  basicinfo;
  basiclist: string[] = [];

  // tslint:disable-next-line:max-line-length
  constructor(private permissionsService: PermissionsService) {

    this.baseinfoSubscription = this.permissionsService.selectedrole.subscribe(selectedRole => {
      this.basicinfo = selectedRole?.permissions;
      
    });
  }

  ngOnDestroy() {
    this.baseinfoSubscription.unsubscribe();
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let retval = false;
    if (this.basicinfo) {
      // Kontrollera om användaren har den/de roller som krävs för att kunna gå till aktuell route.
      // Om användaren har rätt roll så returneras true.

     next.data.permissions.forEach(p => {

      if (this.basicinfo.indexOf(p) !== -1) {

        retval = true;
      }
     });
      /*if (this.basicinfo.indexOf(next.data.permissions) !== -1) {
        return true;
      }*/
    }
    return retval;
  }


}
